import { createContext, useContext } from "react";

// Lets any field anywhere in the submission tree request that the Research
// drawer be opened (e.g. when a citation badge is clicked) without prop
// drilling. Submission.js wraps the tree with the provider.
export const ResearchDrawerContext = createContext({
  openDrawer: () => {},
  isAvailable: false,
});

export const useResearchDrawer = () => useContext(ResearchDrawerContext);
